/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurring_TitleInputs */

const en_recurring_title = /** @type {(inputs: Recurring_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recurring — pending`)
};

const he_recurring_title = /** @type {(inputs: Recurring_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חוזר — ממתין`)
};

/**
* | output |
* | --- |
* | "Recurring — pending" |
*
* @param {Recurring_TitleInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const recurring_title = /** @type {((inputs?: Recurring_TitleInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurring_TitleInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurring_title(inputs)
	return he_recurring_title(inputs)
});